// new URL:
// anthem-ingenio-eligibility-application

import React from "react";
import { FolioIngenio } from "../app-template/AppContent";
import IntroSection from "./intro";
import SideNav from "./sideNav";
import HeaderImg from "./img/header-image.jpg";

function IngenioIEPCS() {
	return (
		<section className="case-study-template ingenio-iep" id="ingenio-iep">
			<div className="header">
				<figure className="hero-image">
					<img src={HeaderImg} alt="Cruise ship in Mediterranean with sunset" />
				</figure>
				<div className="header-title-block">
					<span className="inner">
						<span className="case-study-tags">
							{FolioIngenio.tag01 + " // " + FolioIngenio.tag02}
						</span>
						<h2 className="case-study-title"> {FolioIngenio.caseStudy}</h2>
					</span>
				</div>
			</div>
			<div className="container">
				<SideNav />
				<article className="content">
					<IntroSection />
				</article>
			</div>
		</section>
	);
}

export default IngenioIEPCS;
